import template from './template.html';
import { startsWith } from 'lodash';

const ORIGIN = window.location.origin;
const HOSTS = [
    new URL(ORIGIN).host,
    'localhost:8000',
    'localhost:3000',
    '127.0.0.1:3000',
    '127.0.0.1:8000',
    'web',
];


export default {
    name: 'siteLink',
    template: template,

    props: ['url', 'classes'],

    computed: {
        isModal() {
            if (this.url instanceof String) {
                return this.url.startsWith('modal:');
            }
        },

        isAnchor() {
            if (this.url instanceof String) {
                return this.url.startsWith('#');
            }
        },

        modalSlug() {
            if ( this.url instanceof String && this.isModal ) {
                return this.url.replace('modal:', '');
            }
        },

        relative() {
            let hasHTTP = /^https?:\/\/|^\/\//i.test(this.url);
            let hasTel = /^tel:|^\/\//i.test(this.url);

            return !hasHTTP && !hasTel;
        },

        urlObject() {
            let url = this.url || '';

            if ( this.relative ) {
                return false;
            }

            if ( url.startsWith('//') ) {
                url = 'http:' + url;
            }

            return new URL(url);
        },

        external() {
            if (this.urlObject) {
                return !this.relative && HOSTS.indexOf(this.urlObject.host) === -1;
            }
        },

        relativeURL() {
            if ( this.relative ) {
                return this.url;
            }
            if (this.urlObject) {
                return this.urlObject.href.replace(this.urlObject.origin, '');
            }
            return false;
        },
    },

    methods: {
        triggerScroll() {
            this.$root.triggerScroll();
        },
    }
};